import { environment } from '../../environments/environment';

export const translocoConfig = {
  availableLangs: ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'pt', 'ru', 'tr', 'zh'],
  defaultLang: 'en',
  reRenderOnLangChange: true,
  prodMode: environment.production,
};
